import "./PromoStep.scss";

import ButtonSubmit from "../ButtonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";

import girlPromo from "../../images/girl-promo.jpg";
import giftIcon from "../../images/gift.png";

import { simplyClick } from "../../helpers";

const PromoStep = ({ nextStep }) => {
  const handleContinue = () => {
    simplyClick("cl_lnd_20_free_st1_action", { text: "sign_me_up" });
    nextStep();
  };

  return (
    <>
      <div className="promo__wrapper">
        <div className="user__form-top">
          <h3>
            {" "}
            <img src={giftIcon} alt="gift" className="gift-icon" /> 20 free
            credits to start!
          </h3>
        </div>
        <div className="user__form-content">
          <div className="user__form-image">
            <img src={girlPromo} alt="image_girl" />
          </div>
          <div className="text__wrapper promo_text">
            <p>
              🔑 Unlock premium access: exclusive pics, clips, and chats
            </p>
            <p>
              🤑 Need more credits? <br /> Get extra anytime. Buy more, pay less!
            </p>
          </div>

          <ButtonSubmit
            onClick={handleContinue}
            className={"button__global button__promo first_step_btn"}
            text={"Sign me up"}
            dataAttr="cookies"
          />
          <div className="list_promo">
            <div className="column_promo">
              <ul>
                <li>Free sign up</li>
                <li>Full control over spending</li>
              </ul>
            </div>
            <div className="column_promo">
              <ul>
                <li>No credit card needed</li>
                <li>No recurring charges</li>
              </ul>
            </div>
          </div>
          <ProgressDots total={12} activeCount={1} />
        </div>
      </div>
    </>
  );
};

export default PromoStep;
